
import React from "react";
import "../styles/footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      @2025 RegExport CONSEIL
    </footer>
  );
};

export default Footer;
